import "@/App.css";
import React, { Suspense, lazy } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";

// Layout selection:
//  - Deployment default: REACT_APP_THEME=light|dark (build arg, see docker-compose.yml)
//  - Runtime testing override: append ?style=dark or ?style=light to the URL.
// Both themes ship as separate lazy chunks; only the selected one is fetched,
// so their stylesheets never load together (the two CSS files share selectors).

const DEFAULT_THEME = (process.env.REACT_APP_THEME || "light").toLowerCase();
const urlTheme = new URLSearchParams(window.location.search).get("style");
const theme = urlTheme === "dark" || urlTheme === "light" ? urlTheme : DEFAULT_THEME;

// eslint-disable-next-line no-console
console.info(
  `[theme] active: ${theme}` +
    (urlTheme && urlTheme !== DEFAULT_THEME ? ` (URL override ?style=${urlTheme})` : "") +
    ` — test the other via ?style=${theme === "dark" ? "light" : "dark"}`
);

const Landing =
  theme === "dark"
    ? lazy(() => import("./pages/LandingDark"))
    : lazy(() => import("./pages/Landing"));

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Suspense
          fallback={
            <div
              style={{
                minHeight: "100vh",
                background: theme === "dark" ? "#020617" : "#ffffff",
              }}
            />
          }
        >
          <Routes>
            <Route path="/" element={<Landing />} />
          </Routes>
        </Suspense>
      </BrowserRouter>
      <Toaster />
    </div>
  );
}

export default App;